export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000';
export const DEFAULT_COMPANY_ID =
  import.meta.env.VITE_DEFAULT_COMPANY_ID ?? '11111111-1111-1111-1111-111111111111';
